module.exports = __webpack_public_path__ + "src/images/myclemson-logo.4e972f746cd7ed8232759378744f4b94.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/myclemson-logo.png
// module id = 122
// module chunks = 0